import analytics from '../../helpers/Analytics';
import {
  GET_ALL_APPROVALS,
  ADD_PENDING_APPROVAL_TASK_IDS,
  REMOVE_PENDING_APPROVAL_TASK_IDS,
} from '../../state/actionTypes';
import ClockInService from './clockin.service';

export default {};
export const addPendingApprovalTaskIds = (taskIds) => ({
  type: ADD_PENDING_APPROVAL_TASK_IDS,
  payload: { taskIds },
});
export const removePendingApprovalTaskIds = (taskIds) => ({
  type: REMOVE_PENDING_APPROVAL_TASK_IDS,
  payload: { taskIds },
});
export const getApprovals = (source = '') => async (dispatch) => {
  analytics.track('GetApprovals', { source });
  const { data } = await ClockInService.getAllApprovals();
  if (!data) return false;
  dispatch({
    type: GET_ALL_APPROVALS,
    payload: {
      approvals: data,
    },
  });
  return true;
};
